import { getLocalStorage } from './helper';

import {
    atom,
} from 'recoil';

export const historyStore = atom<string[]>({
    key: 'historyStore',
    default: getLocalStorage('history', []),
});